@let reviewForm = form();
@let shouldShowError = reviewForm.errors?.instanceAtRequired && reviewForm.controls.instance_at.touched;
@let shouldShowInvalidError = reviewForm.controls.instance_at.errors?.instanceAtInvalid && reviewForm.controls.instance_at.touched;
@let shouldShowOutOfRangeError = reviewForm.controls.instance_at.errors?.instanceAtOutOfRange && reviewForm.controls.instance_at.touched;

<div [formGroup]="reviewForm">
  <div class="flex gap-2 items-end">

        <app-pan-datetime-picker
          class="flex-1"
          [min]="minDate()"
          [max]="maxDate()"
          [disabled]="readonly()"
          [dateTime]="reviewForm.controls.instance_at.value"
          [dateLabel]="'Incident Date (MM/DD/YYYY)'"
          [timeLabel]="'Incident Time (HH:MM AM/PM)'"
          (dateChange)="onDateChange($event)"
          (dateTimeChange)="onDateTimeChange($event)"
          (invalidDate)="onInvalidDate()"
          placeholder="Select date"
          [color]="shouldShowError || shouldShowInvalidError || shouldShowOutOfRangeError ? 'danger' : 'default'"
        />
        @if (displayTimezone() && timezone()) {
          <app-pan-chip color="info" [size]="'lg'">{{ timezone() }}</app-pan-chip>
        }
  </div>

  @if (displayTimezone() && !timezone()) {
    <app-pan-inline-alert class="my-2" type="danger">
      Timezone information is not available for the selected location. Please ensure the location has a timezone set to have the incident
      date displayed in the correct timezone.
    </app-pan-inline-alert>
  }

  @if (shouldShowError) {
    <div class="text-danger mt-1" role="alert" data-testid="instanceAtError">Incident date is required.</div>
  }
  @if (shouldShowInvalidError) {
    <div class="text-danger mt-1" role="alert" data-testid="instanceAtInvalidError">Incident date is invalid.</div>
  }
  @if (shouldShowOutOfRangeError) {
    <div class="text-danger mt-1" role="alert" data-testid="instanceAtOutOfRangeError">Incident date must be within the last 15 days.</div>
  }
</div>
